<div class="bg-light" style="margin:0px !important;">
  <router-outlet></router-outlet>
</div>